import { io } from "socket.io-client";

let socket = null;

/**
 * Initialize Socket.io connection
 * @param {string} userId - The user ID to join notification room
 * @returns {Socket} The socket instance
 */
export const initializeSocket = (userId) => {
  if (!socket && userId) {
    const SOCKET_URL = process.env.NEXT_PUBLIC_API_URL;

    socket = io(SOCKET_URL, {
      withCredentials: true,
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
    });

    socket.on("connect", () => {
      // console.log("[Socket] Connected to server:", socket.id);

      // Join user-specific room for notifications
      socket.emit("join-user-room", userId);
    });

    socket.on("room-joined", (data) => {
      console.log("[Socket] Joined notification room:", data);
    });

    socket.on("disconnect", (reason) => {
      console.log("[Socket] Disconnected from server:", reason);
    });

    socket.on("connect_error", (error) => {
      console.error("[Socket] Connection error:", error);
    });

    socket.on("reconnect", (attemptNumber) => {
      // console.log("[Socket] Reconnected after", attemptNumber, "attempts");
      // Rejoin room after reconnection
      socket.emit("join-user-room", userId);
    });
  }

  return socket;
};

/**
 * Get the current Socket.io instance
 * @returns {Socket|null} The socket instance or null
 */
export const getSocket = () => {
  if (!socket) {
    console.warn("[Socket] Socket not initialized yet");
  }
  return socket;
};

/**
 * Disconnect and clear the socket instance
 */
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    // console.log("[Socket] Socket disconnected and cleared");
  }
};

export default { initializeSocket, getSocket, disconnectSocket };
